import { z } from "zod";

export const deleteSegment = { input: z.string(), output: z.null() };
